module.exports = __webpack_public_path__ + "static/img/2296_phase_function_Paper_PointsHejduk_Prediction.ed5e2a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2296_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ihXW
// module chunks = 0